import React from 'react';
import MessageTile from './MessageTile';
import useMessages from '../../hooks/useMessages';
import './Message.scss';

const Messages = ({ onSelect, selectedId }) => {
  const { messages, loadMore, loading } = useMessages();

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    // Load more when user is 50px from the bottom
    if (scrollHeight - scrollTop <= clientHeight + 50) {
      loadMore();
    }
  };

  return (
    <div className='messages' onScroll={handleScroll}>
      {messages.map((msg) => (
        <MessageTile
          key={msg.id}
          data={msg}
          isSelected={selectedId === msg.id}
          onClick={() => onSelect(msg)}
        />
      ))}
      {loading && <div className='messages__loading'>Loading more...</div>}
    </div>
  );
};

export default Messages;
